import '@vaadin/vaadin-lumo-styles/lumo.css';
import { Router } from '@vaadin/router';
import './_/fb/init';
import { getAuth, onAuthStateChanged, User } from 'firebase/auth';
import './home';
import { userService } from './_/user.service';
import { callFunc } from './_/services/api.service';

class AppInitializer {
  private static instance: AppInitializer;
  private router: Router;
  private outlet: HTMLElement;
  private pageCache: Record<string, HTMLElement> = {};
  private divContainer: HTMLElement | null = null;
  private readonly USER_SITES = 'bms-usr-sites';

  private constructor() {
    this.router = new Router(null);
    this.outlet = document.getElementById('outlet') as HTMLElement;
  }

  static getInstance(): AppInitializer {
    if (!AppInitializer.instance) {
      AppInitializer.instance = new AppInitializer();
    }
    return AppInitializer.instance;
  }

  public async init(): Promise<void> {
    const auth = getAuth();
    onAuthStateChanged(auth, this.handleAuthStateChange.bind(this));
  }

  private async handleAuthStateChange(user: User | null): Promise<void> {
    this.outlet.innerHTML = '';
    const path = window.location.pathname;
    if (!user) {
      return this.handleUnauthenticatedUser(path);
    }
    await this.handleAuthenticatedUser(user, path);
  }
  private handleUnauthenticatedUser(path: string): void {
    this.initRouter([]);
    Router.go(path.includes('login') ? path : '/login');
  }

  private async handleAuthenticatedUser(
    user: User,
    _path: string
  ): Promise<void> {
    const userDtl = await this.createUserInfo(user);
    const mods: any = userDtl.mods.map((x: any) => x.mod);
    userService.setUser(userDtl);
    // listenChanges();
    const layout = document.createElement('home-page');
    this.outlet.appendChild(layout);
    this.initRouter(mods);
    await this.waitForElement('#content-container', layout);
    if (_path.includes('login')) {
      const login_tags: any = document.getElementsByTagName('login-page');
      login_tags[0].style.display = 'none';
    }
    localStorage.setItem(this.USER_SITES, JSON.stringify([1, 2, 3, 4]));

    console.log('_path', _path);
    Router.go(
      _path.includes('login') || _path === '/'
        ? `/${userDtl.mods[0].path}`
        : _path
    );
  }

  private async createUserInfo(user: any): Promise<any> {
    const sites = await callFunc('authInfo', { uid: user.uid },'GET');
    let site = sites[0];
    userService.setSiteInfo(site['sites']);
    userService.setUserName(site.usrnm);
    userService.setModes(site['modes']);
    const appData = {
      "uId": site.uid,
      "bId": 0,
      "sId": site.sites[0].id,
      "sNm": site.sites[0].name,
      "uNm": site.usrnm
    }
    localStorage.setItem('appData', JSON.stringify(appData));
    // const sid = localStorage.getItem('sid');
    // if (sid) {
    //   site = sites.find((x: any) => x.sid == Number(sid));
    // }
    // if (!site.is_act) {
    //   showMessage('Your account has been deactivated.', 'error');
    //   signOut(getAuth());
    // }
    // if (site.rba) {
    //   site.mods = this.processModules(site.mods, site.rba);
    // } else {
    //   site.mods = site.mods.sort((a: any, b: any) => a.ord - b.ord);
    // }

    // const mod = [
    //   {
    //     nm: 'Dashboard',
    //     mod: 'dashboard',
    //     ord: 1,
    //   },
    //   {
    //     nm: 'Violation',
    //     mod: 'violation',
    //     ord: 1,
    //   },
    //   {
    //     nm: 'Reports',
    //     mod: 'reports',
    //     ord: 1,
    //   },
    //   {
    //     nm: 'Role',
    //     mod: 'role',
    //     ord: 1,
    //   },
    // ];

    return {
      usrid: site.usrid,
      tkn: user.refreshToken,
      em: user.email,
      nm: user.displayName,
      mob: site.mob,
      uid: user.uid,
      sites: sites,
      site: { id: site.sid, nm: site.site_nm, tz: site.tz },
      biz: { id: site.bid, nm: site.biz_nm },
      mods: site['modes'] || [],
    };
  }

  private processModules(mods: any[], rba: any[]): any[] {
    return mods
      .map((mod: any) => {
        const modRba = [
          ...new Set(
            rba.filter((item) => item.mod === mod.mod).map((item) => item.cod)
          ),
        ];
        return modRba.length ? { ...mod, rba: modRba } : null;
      })
      .filter(Boolean) // Remove null values
      .sort((a: any, b: any) => a.ord - b.ord);
  }

  private async waitForElement(
    selector: string,
    layout: HTMLElement
  ): Promise<HTMLElement> {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const element = layout.shadowRoot?.querySelector(selector);
        if (element) {
          clearInterval(interval);
          this.divContainer = element as HTMLElement;
          resolve(element as HTMLElement);
        }
      }, 100);
    });
  }

  private showPage(mod: string): void {
    if (!this.divContainer) {
      console.error('Page content container not found');
      return;
    }
    if (!this.pageCache[mod]) {
      this.pageCache[mod] = document.createElement(`${mod}-page`);
    }
    this.divContainer.innerHTML = '';
    this.divContainer.appendChild(this.pageCache[mod]);
  }

  private initRouter(_mods: []): void {
    const baseRoutes = [
      {
        path: '/dashboard',
        component: 'dashboard-page',
        action: async () => {
          await import('./dashboard/dashboard');
          this.showPage('dashboard');
        },
      },
      {
        path: '/violation',
        component: 'violation-page',
        action: async () => {
          await import('./violation/violation');
          this.showPage('violation');
        },
      },
      // {
      //   path: '/reports',
      //   component: 'reports-page',
      //   action: async () => {
      //     await import('./reports/report');
      //     this.showPage('reports');
      //   },
      // },
      {
          path: '/reports',
          component: 'div',
          action: async () => {
              await import('./_reports');
              this.showPage('reports');
          },
      },
      // {
      //   path: '/mul-rep',
      //   component: 'mul-rep-page',
      //   action: async () => {
      //     await import('./reports/multi-report');
      //     this.showPage('mul-rep');
      //   },
      // },

      {
          path: '/mul-rep',
          component: 'div',
          action: async () => {
              await import('./reports/multi-report');
              this.showPage('mul');
          },
      },
      {
        path: '/analytics',
        component: 'analytics-page',
        action: async () => {
          await import('./reports/analytics');
          this.showPage('analytics');
        },
      },
      // {
      //   path: '/deviceLog',
      //   component: 'devicelog-page',
      //   action: async () => {
      //     await import('./deviceLogs/deviceLogs');
      //     this.showPage('devicelog');
      //   },
      // },
      {
            path: '/logs',
            component: 'div',
            action: async () => {
                await import('./_logs');
                this.showPage('logs');
            },
      },
      {
        path: '/hardwareHealth',
        component: 'health-page',
        action: async () => {
          await import('./hardwareHealth/hardwareHealth');
          this.showPage('health');
        },
      },
      {
        path: '/temp',
        component: 'temp-page',
        action: async () => {
          await import('./temporary_data/temporary_data');
          this.showPage('temp');
        },
      },
      {
        path: '/role',
        component: 'role-page',
        action: async () => {
          await import('./role/role');
          this.showPage('role');
        },
      },
      {
        path: '/dashboard-v2',
        component: 'acdash-page',
        action: async () => {
          await import('./ac/_dashboard');
          this.showPage('acdash');
        },
      },
      {
        path: '/manage',
        component: 'manage-page',
        action: async () => {
          await import('./ac/manage');
          this.showPage('manage');
        },
      },
    ];

    const additionalRoutes = [
      {
        path: '/login',
        action: async () => {
          await import('./auth/login');
          const layout = document.createElement('login-page');
          this.outlet.appendChild(layout);
        },
      },
    ];

    const allRoutes = [...baseRoutes, ...additionalRoutes];
    this.router.setRoutes(allRoutes);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  AppInitializer.getInstance().init();
});
